var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCheck = function SvgIcCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m11.991 15.892-5.774-5.775-3.3 3.3 9.074 9.074 13.2-13.2-3.3-3.299z",
    clipRule: "evenodd"
  })));
};
export { SvgIcCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuOTkxMyAxNS44OTE1TDYuMjE2NTggMTAuMTE2OEwyLjkxNjc1IDEzLjQxNjZMMTEuOTkxMyAyMi40OTEyTDI1LjE5MDYgOS4yOTE4NEwyMS44OTA4IDUuOTkyTDExLjk5MTMgMTUuODkxNVoiIC8+Cjwvc3ZnPgo=";